import { Box } from "@mui/material";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    modifyAllergy,
    getAllergysError,
    getAllergysStatus,
    getAllergysLoading,
    getAllergysSuccess,
} from "../../features/allergySlice";
import { useLocation, useNavigate } from "react-router-dom";
import BackButton from "../../components/backButton";
import AllergyForm from "./allergyForm";
import RestaurantAppBar from "../../components/restaurantTopBar";
import { getImageFormFields } from "../../global/functions/imageHelper";
import { useTranslation } from "react-i18next";

const ModifyAllergy = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state.allergy;
    const status = useSelector(getAllergysStatus);
    const error = useSelector(getAllergysError);
    const loading = useSelector(getAllergysLoading);
    const success = useSelector(getAllergysSuccess);
    const [previewImage, setPreviewImage] = useState(null);

    const initialValues = {
        name: data.name ?? "",
        icon: data.icon ?? "",
    };

    const handleFormSubmit = (values) => {
        const requestBody = {
            name: values.name,
            ...getImageFormFields(previewImage, "icon"),
        };
        dispatch(modifyAllergy({ body: requestBody, allergyId: data._id }))
    };

    useEffect(() => {
        if (status === "modifySuccess") {
            navigate("/allergy");
            toast.success(success);
        } else if (status === "modifyError") {
            toast.error(error);
        }
    }, [status, error, dispatch, navigate, success]);

    return (
        <div className="main-application">
            <RestaurantAppBar />
            <Box m="20px" className="main-application">
                <BackButton />
                <Header title={t("headers.editAllergy")} subtitle={t("headers.editAllergySub")} />
                <AllergyForm
                    buttonText={t("common.edit")}
                    handleFormSubmit={handleFormSubmit}
                    initialValues={initialValues}
                    previewImage={previewImage}
                    setPreviewImage={setPreviewImage}
                    loading={loading}
                    image={data.icon}
                />
            </Box>
        </div>
    );
};

export default ModifyAllergy;
